// Forma de pagamento das vendas no balcão (produto, vale, pacote): Pix, cartão ou dinheiro.
import { useState } from 'react';
import { useMachines, useMe } from '../lib/data.ts';
import { Icon, type IconName } from './Icon.tsx';

export type SaleMethod = 'pix' | 'credit' | 'debit' | 'cash';
const PILLS: Array<[SaleMethod, string, IconName]> = [['pix', 'Pix', 'card'], ['credit', 'Crédito', 'card'], ['debit', 'Débito', 'card'], ['cash', 'Dinheiro', 'cash']];

export function useSalePay() {
  const me = useMe().data!;
  const machines = (useMachines().data ?? []).filter((m) => m.active);
  const [method, setMethod] = useState<SaleMethod | null>(null);
  const [machineId, setMachineId] = useState<string | null>(null);
  const [installments, setInstallments] = useState(1);
  const card = method === 'credit' || method === 'debit';
  const machine = card ? machineId ?? machines[0]?.id ?? null : null;
  const inst = me.salon.settings.installments;
  const missing = !method ? 'Escolha o pagamento' : card && !machine ? 'Cadastre uma maquininha' : '';
  const payments = (amountCents: number) => [{ method: method!, amountCents, ...(machine ? { machineId: machine } : {}), installments: method === 'credit' ? installments : 1 }];
  const view = (
    <>
      <div className="kit-methods">{PILLS.filter(([m]) => me.salon.settings.methods[m]).map(([m, label, icon]) => (
        <button key={m} className={method === m ? 'on' : ''} aria-pressed={method === m} onClick={() => setMethod(m)}><Icon name={icon} />{label}</button>
      ))}</div>
      {card && machines.length > 1 && <div className="chipset soft">{machines.map((m) => <button key={m.id} className={machine === m.id ? 'on' : ''} aria-pressed={machine === m.id} onClick={() => setMachineId(m.id)}>{m.name}</button>)}</div>}
      {method === 'credit' && inst.on && <div className="chipset soft">{Array.from({ length: inst.max }, (_, i) => i + 1).map((n) => <button key={n} className={installments === n ? 'on' : ''} aria-pressed={installments === n} onClick={() => setInstallments(n)}>{n === 1 ? 'À vista' : `${n}x`}</button>)}</div>}
    </>
  );
  return { view, missing, payments, method };
}
